import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import { Badge } from 'antd';
import axios from 'axios';
import { shopDeliveryText } from '../../utils/display';
import NumberFormat from 'react-number-format';

export type Props = {
  items?: any;
  from?: string;
};

const ShopList: React.FC<Props> = (props) => {
  const { items = [], from } = props;
  const [fromPage, setFromPage] = useState<any>('');
  useEffect(() => {
    setFromPage(from);
    getPromotion(items);
  }, [items]);

  const navigate = useNavigate();
  const [shopPromotion, setShopPromotion] = useState<any>([]);

  const getPromotion = async (items: any) => {
    const data =
      items.length > 0
        ? items?.map((item: any) => {
            return { sellerId: item?.code };
          })
        : [];

    if (data.length > 0) {
      const promotions = await axios.post(`/promotions/seller/has-promotion`, {
        sellers: data,
      });
      setShopPromotion(promotions);
    }
  };

  const getShopPromotion = (sellerId: any) => {
    let shops = shopPromotion?.data?.filter(
      (item: any) => item?.sellerId === sellerId
    );
    const text = 'ร้านค้าเข้าร่วมโปรโมชั่น';
    return <div>{shops[0].joinPromotion ? text : ''}</div>;
  };

  const checkPromotion = (sellerId: any) => {
    if (sellerId && shopPromotion?.data) {
      let shops = shopPromotion?.data?.filter(
        (item: any) => item?.sellerId === sellerId
      );
      return shops[0]?.joinPromotion;
    }
    return false;
  };

  const shopListItem = (item: any) => {
    return (
      <>
        <div className={styles.shopItemWrapper}>
          <div className={styles.imageWrapper}>
            <img
              src={
                item?.document?.shopImageUrl
                  ? item?.document?.shopImageUrl
                  : '/images/logo-promptdee-trans-blue.svg'
              }
              alt=''
              className={styles.img}
            />
          </div>
          <div className={styles.detailWrapper}>
            {/* shop name */}
            <div className={styles.lineWrapper}>
              <div className={styles.lineIcon}>
                <img
                  src='/images/shops/shop-name.svg'
                  className={styles.imgIcon}
                  alt=''
                />
              </div>
              <div className={styles.lineText}>{item.name}</div>
            </div>
            {item.phoneNumber && !item.phoneNumberReserve ? (
              <div className={styles.lineWrapper}>
                <div className={styles.lineIcon}>
                  <img
                    src='/images/shops/shop-phone.svg'
                    className={styles.imgIcon}
                    alt=''
                  />
                </div>
                <div className={styles.lineText}>
                  <a href={`tel:${item.phoneNumber}`}>
                    <NumberFormat
                      format='###-###-####'
                      value={item.phoneNumber}
                      displayType='text'
                      style={{ color: '#000000' }}
                    ></NumberFormat>
                  </a>
                </div>
              </div>
            ) : (
              <div className={styles.lineWrapper}>
                <div className={styles.lineIcon}>
                  <img
                    src='/images/shops/shop-phone.svg'
                    className={styles.imgIcon}
                    alt=''
                  />
                </div>
                <div className={styles.lineText}>
                  <a href={`tel:${item.phoneNumber}`}>
                    <NumberFormat
                      format='###-###-####'
                      value={item.phoneNumber}
                      displayType='text'
                      style={{ color: '#000000' }}
                    ></NumberFormat>
                  </a>
                  &nbsp; /&nbsp;
                  <a href={`tel:${item.phoneNumberReserve}`}>
                    <NumberFormat
                      format='###-###-####'
                      value={item.phoneNumberReserve}
                      displayType='text'
                      style={{ color: '#000000' }}
                    ></NumberFormat>
                  </a>
                </div>
              </div>
            )}

            {item.workingTimeStart && item.workingTimeEnd && (
              <>
                <div className={styles.lineWrapper}>
                  <div className={styles.lineIcon}>
                    <img
                      src='/images/shops/shop-time.svg'
                      className={styles.imgIcon}
                      alt=''
                    />
                  </div>
                  <div className={styles.lineText}>
                    ร้านเปิด {item.workingTimeStart} - {item.workingTimeEnd} น.
                  </div>
                </div>
              </>
            )}

            {/* shop location */}
            <div className={styles.lineWrapper}>
              <div className={styles.lineIcon}>
                <img
                  src='/images/shops/shop-location.svg'
                  className={styles.imgIcon}
                  alt=''
                />
              </div>
              <div className={styles.lineText}>
                ระยะทาง {item.dist?.calculated?.toFixed(1)} กม.
              </div>
            </div>
            {/* shop shipments */}
            <div className={styles.lineWrapper}>
              <div className={styles.lineIcon}>
                <img
                  src='/images/shops/shop-shipment.svg'
                  className={styles.imgIcon}
                  alt=''
                />
              </div>
              <div className={styles.lineText}>{shopDeliveryText(item)}</div>
            </div>
          </div>
        </div>
        {/* {item.numOfProduct > 0 ? (
          <div className={styles.numOfProduct}>
            ดู {item.numOfProduct} สินค้าของร้าน
          </div>
        ) : (
          <div className={`${styles.numOfProduct} ${styles.zero}`}>
            โทรติดต่อร้านค้าได้เลย!
          </div>
        )} */}
        <div className={styles.numOfProduct}>
          ดู {item.numOfProduct} สินค้าของร้าน
        </div>
      </>
    );
  };

  const shopList = (item: any) => {
    return (
      <>
        {item.numOfProduct > 0 ? (
          <div
            className={styles.shopItem}
            onClick={() => {
              navigate(`/shops/?from=${fromPage}&id=${item?._id}`);
            }}
          >
            {shopListItem(item)}
          </div>
        ) : (
          <div
            className={styles.shopItem}
            onClick={() => {
              navigate(
                `/shops/?from=${fromPage}&id=${item?._id ? item?._id : ''}`
              );
            }}
          >
            {shopListItem(item)}
          </div>
          // <a
          //   className={`${styles.shopItem} ${styles.shopItemLink}`}
          //   href={`tel:${item.phoneNumber}`}
          // >
          //   {shopListItem(item)}
          // </a>
        )}
      </>
    );
  };

  return (
    <div className={styles.shopListWrapper}>
      {items.map((item: any, index: number) => (
        <div className={styles.item} key={index}>
          {checkPromotion(item.code) ? (
            <Badge.Ribbon
              text={getShopPromotion(item.code)}
              color='volcano'
              className={styles.shopAntRibbon}
            >
              {shopList(item)}
            </Badge.Ribbon>
          ) : (
            shopList(item)
          )}
        </div>
      ))}
    </div>
  );
};
export default ShopList;
